import { CATEGORY_CHANCES, CATEGORY_RISKS, CATEGORY_INFOS } from '@/model/post/categories'

export default {
    category: {
        [CATEGORY_RISKS]: 'Risiks',
        [CATEGORY_INFOS]: 'Information',
        [CATEGORY_CHANCES]: 'Chances'
    },
    title: 'Post title',
    description: 'Write your comment here',
    macrotrend: 'Select a Macro trend',

    submit: 'Submit',
    cancel: 'Cancel',
    success: 'Your post "{title}" was successfully saved',

    validation: {
        title: {
            required: 'Please enter a title',
            length: 'The title should not contain more than 512 characters'
        },
        description: {
            required: 'Please enter a contribution',
            length: 'The contribution should not be longer than 4000 characters'
        }
    }
}
